import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    editordashboard: {},
};

const EditorDashBoardSlice = createSlice({
    name: 'editordashboard',
    initialState,
    reducers: {
        setEditorDashBoard(state, action) {
            state.editordashboard = action.payload;
        }


    },
});




export const EditorDashBoardAPi = (tokendata) => async (dispatch) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/editor/dashboard`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "jfdd")
            dispatch(setEditorDashBoard(res?.data))
        })
        .catch((err) => {
            console.log(err?.response, "errerrr");

        })
}

export const {setEditorDashBoard} = EditorDashBoardSlice.actions;
const EditorDashboardReducer = EditorDashBoardSlice.reducer;

export default EditorDashboardReducer;
